<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" :sm="6" :md="6">
        <DatapointsLiveChart />
      </v-col>

      <LogTable />

      <v-col cols="12" :sm="6" :md="6" class="d-flex fhight" align-self="start">
        <v-row align="center" justify="start">
          <ActiveUsersTable />
          <LogChart />
        </v-row>
      </v-col>
      <!-- Create Log data graph -->
      <!-- Create Active users table -->
    </v-row>
  </v-container>
</template>

<script>
import LogTable from "@/components/common/LogTable";
import LogChart from "@/components/common/LogChart";
import DatapointsLiveChart from "@/components/common/DatapointsLiveChart";
import ActiveUsersTable from "@/components/common/ActiveUsersTable";

export default {
  name: "AdminDashboard",
  data() {
    return {};
  },

  components: {
    LogTable,
    ActiveUsersTable,
    LogChart,
    DatapointsLiveChart
  }
};
</script>
<style scoped>
.fhight {
  height: 68vh;
}
</style>
